import { config } from "../../Config";

const GetPendingApprovals = async (adminUserId) => {
  if (!adminUserId) return { success: false, error: "Missing userId", pending: [], count: 0 };
  const url = new URL(config.getPendingApprovals);
  url.searchParams.set("userId", adminUserId);
  try {
    const res = await fetch(url.toString(), { method: "GET" });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      return { success: false, error: data.error || `HTTP ${res.status}`, pending: [], count: 0 };
    }
    return {
      success: true,
      pending: Array.isArray(data.pending) ? data.pending : [],
      count: Number.isInteger(data.count) ? data.count : (data.pending ? data.pending.length : 0),
    };
  } catch (e) {
    return { success: false, error: e.message, pending: [], count: 0 };
  }
};

export default GetPendingApprovals;
